import { TFunc } from '@Translations/types';

export const upsertLiftStationMessages = (
	t: TFunc,
	ns: string,
): Record<string, string> => ({
	'liftStation/update/success': t('Facility updated successfully', { ns }),
	'liftStation/create/success': t('Facility created successfully', { ns }),
	'liftStation/create/error': t('Failed to create facility', { ns }),
	'liftStation/upsert/error': t('Failed to create or update facility', {
		ns,
	}),
	'liftStation/update/error': t('Failed to update facility', { ns }),
	'liftStation/create/duplicate': t(
		'Facility exists, please choose a new name',
		{ ns },
	),
	'liftStation/update/duplicate': t(
		'Facility exists, please choose a new name',
		{ ns },
	),
});
